import HtmlTrans from 'components/shared/HtmlTrans';
import {
  StyledHero,
  StyledHeroContainer,
  StyledHeroContent,
  StyledHeroDesc,
  StyledHeroImage,
  StyledHeroTitle
} from './SectionHero.styled';
import { SectionHeroProps } from './SectionHero.types';

const SectionHero: React.FC<SectionHeroProps> = ({ image, title, desc }) => {
  return (
    <StyledHero>
      <StyledHeroContainer>
        <StyledHeroImage src={image} alt="" />
        <StyledHeroContent>
          <StyledHeroTitle as="h2" editorial alignLeft>
            <HtmlTrans ns="developer-career-report-2024" i18nKey={title} />
          </StyledHeroTitle>
          {desc && (
            <StyledHeroDesc>
              <HtmlTrans ns="developer-career-report-2024" i18nKey={desc} />
            </StyledHeroDesc>
          )}
        </StyledHeroContent>
      </StyledHeroContainer>
    </StyledHero>
  );
};

export default SectionHero;
